import { IResidentialUserStoreType } from "slices/currentUser/currentUser.reducer";
import {
  PackageDeliveryPolicies,
  PackageDeliveryPreferencesEnum,
} from "types/generalSettingsEnums";
import { FetchDesignSelectOptionType } from "views/fetch-design/FetchDesignSelect/FetchDesignSelect";
import { ResidentialUserProfileValues } from "domains/user-management/models/ResidentialUserProfile/types/ResidentialUserProfileValues";

export function getInitialValues(
  marketOptions: FetchDesignSelectOptionType[],
  residentialUser: IResidentialUserStoreType,
  buildingOptions: FetchDesignSelectOptionType[],
  buildingUnitOptions: FetchDesignSelectOptionType[],
  buildingLeavePolicy: PackageDeliveryPolicies,
): ResidentialUserProfileValues {
  return {
    timezone: residentialUser.warehouseTimezone,
    market:
      marketOptions.find((option) => {
        return option.value === residentialUser.market;
      }) || null,
    building:
      buildingOptions.find((option) => {
        return option.value === residentialUser.buildingId;
      }) || null,
    buildingUnit:
      buildingUnitOptions.find((option) => {
        return option.value === residentialUser.buildingUnitId;
      }) || null,
    leaveAtDoor:
      buildingLeavePolicy === PackageDeliveryPolicies.BUILDING_DO_NOT_LEAVE
        ? false
        : residentialUser.packageDeliveryPreference ===
          PackageDeliveryPreferencesEnum.LEAVE,
    termsAccepted: !!residentialUser.termsAccepted,
    leaveLiabilityAccepted: !!residentialUser.leaveLiabilityAccepted,
  };
}
